import { IonCol, IonGrid, IonModal, IonRow } from "@ionic/react";
import React, { useRef, useEffect, useState } from "react";
import GraphAromDescriptionModal from "./modals/graph-arom-description-modal";

interface Props {
  assessmentName: string;
  left: number;
  right: number;
  imgPath: any;
}

const AromResultCard: React.FC<Props> = ({
  assessmentName,
  left,
  right,
  imgPath,
}) => {
  let angle_right = right;
  let angle_left = left;
  let x2_first = "50%";
  let x2_second = "50%";
  let y2_first = "83%";
  let y2_second = "80%";
  if (
    assessmentName === "Elbow Flexion" ||
    assessmentName === "Elbow Extension"
  ) {
    y2_first = "73%";
    y2_second = "70%";
  } else if (assessmentName === "Internal Rotation") {
    angle_right = -right;
    angle_left = -left;
    x2_first = "30%";
    x2_second = "33%";
    y2_first = "50%";
    y2_second = "50%";
  } else if (assessmentName === "External Rotation") {
    x2_first = "30%";
    x2_second = "33%";
    y2_first = "50%";
    y2_second = "50%";
  }
  const [GraphAsseDesc, setGraphAsseDesc] = useState(false);
  const [graphNameToShowInfo, setGraphNameToShowInfo] = useState("");

  function handleGraphAsseDesc(assessmentName: string) {
    debugger;
    console.log("Before setting GraphAsseDesc:", GraphAsseDesc);
    setGraphAsseDesc(true);
    setGraphNameToShowInfo(assessmentName);
  }

  function getGraphTitleImage() {
    if (
      assessmentName === "Shoulder Abduction" ||
      assessmentName === "Shoulder Adduction"
    ) {
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="26"
          height="33"
          viewBox="0 0 26 33"
          fill="none"
        >
          <g filter="url(#filter0_d_8478_40592)">
            <path
              d="M12.9982 5.76271C14.241 5.76271 15.2475 4.76806 15.2475 3.53995C15.2475 2.31185 14.241 1.3172 12.9982 1.3172C11.7553 1.3172 10.7488 2.31185 10.7488 3.53995C10.7488 4.76806 11.7553 5.76271 12.9982 5.76271Z"
              fill="black"
            />
            <path
              d="M16.5866 8.71827C16.5338 8.73193 16.486 8.7431 16.4446 8.7518C16.4911 8.73814 16.5388 8.72324 16.5853 8.70709C16.5853 8.71082 16.5866 8.71454 16.5866 8.71827Z"
              fill="black"
            />
            <path
              d="M22 1.31619C21.9975 1.98053 21.9108 4.03689 20.4066 5.99887C19.4503 7.24809 18.1208 8.20549 16.5839 8.70716C16.5374 8.7233 16.4897 8.7382 16.4432 8.75186C16.4193 8.75807 16.3967 8.76304 16.3766 8.76676V9.15792C16.3766 13.9536 16.3741 18.7481 16.3715 23.5437C16.2434 24.0529 15.7772 24.4142 15.2456 24.413C14.7153 24.4117 14.2503 24.0516 14.1222 23.5437V16.8755H11.8728V23.5437C11.7497 23.992 11.3978 24.3347 10.9731 24.413C10.4201 24.5148 9.81946 24.1559 9.62343 23.5437V8.77297C7.9986 8.28993 6.59243 7.30397 5.59341 5.99887C4.09048 4.03689 4.00251 1.98053 4 1.31619C4.18472 0.884054 4.60193 0.593481 5.06688 0.57113C5.57205 0.547536 6.04705 0.845559 6.24937 1.31619C6.24937 4.37216 8.76892 6.8619 11.8615 6.87307C12.6155 6.87556 14.4363 6.94013 14.7191 6.87307C14.7379 6.86811 14.9817 6.8085 15.3147 6.74517C15.3499 6.73896 15.3738 6.734 15.375 6.734C17.8757 6.16775 19.7506 3.95369 19.7506 1.31619C19.9529 0.845559 20.428 0.547536 20.9331 0.57113C21.3993 0.593481 21.8153 0.884054 22 1.31619Z"
              fill="black"
            />
            <path
              d="M16.4421 8.75281C16.4195 8.76026 16.3981 8.76771 16.3755 8.77392V8.76771C16.3956 8.76398 16.4182 8.75902 16.4421 8.75281Z"
              fill="black"
            />
          </g>
          <defs>
            <filter
              id="filter0_d_8478_40592"
              x="0"
              y="0.569824"
              width="26"
              height="31.8603"
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset dy="4" />
              <feGaussianBlur stdDeviation="2" />
              <feComposite in2="hardAlpha" operator="out" />
              <feColorMatrix
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
              />
              <feBlend
                mode="normal"
                in2="BackgroundImageFix"
                result="effect1_dropShadow_8478_40592"
              />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="effect1_dropShadow_8478_40592"
                result="shape"
              />
            </filter>
          </defs>
        </svg>
      );
    } else if (
      assessmentName === "Shoulder Flexion" ||
      assessmentName === "Shoulder Extension"
    ) {
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="15"
          height="37"
          viewBox="0 0 15 37"
          fill="none"
        >
          <g filter="url(#filter0_d_8478_40466)">
            <path
              d="M8.01751 19.6045C8.01751 18.8632 7.44772 18.2623 6.74484 18.2623C6.04196 18.2623 5.47217 18.8632 5.47217 19.6045V27.6577C5.47217 28.3989 6.04196 28.9999 6.74484 28.9999C7.44772 28.9999 8.01751 28.3989 8.01751 27.6577V19.6045Z"
              fill="#31344E"
            />
            <path
              d="M5.54864 8.90634C5.36511 8.96851 4.83996 9.17337 4.43807 9.74415C4.02545 10.3319 4 10.9408 4 11.1414V17.8934C4 19.1889 4.9967 20.2401 6.22517 20.2401H7.13479C8.36326 20.2401 9.35996 19.1889 9.35996 17.8934V11.1414C9.35996 10.9903 9.34656 10.7769 9.2836 10.5325C9.2836 10.5325 9.15901 10.0479 8.8241 9.617C8.41014 9.08436 7.14149 8.66051 5.54864 8.90634Z"
              fill="#31344E"
            />
            <path
              d="M6.76023 11.3115L6.55258 11.2479C6.33824 11.1632 5.98725 10.9823 5.79032 10.6079C5.60143 10.2491 5.63492 9.86194 5.68047 9.58644C5.82917 8.70059 6.71736 5.40304 8.02888 0.970988C8.22313 0.258921 8.92779 -0.152213 9.60432 0.0526474L9.81196 0.116225C10.4872 0.321086 10.877 1.06424 10.6827 1.77772L8.33433 10.3932C8.14007 11.1052 7.43542 11.5164 6.75889 11.3115H6.76023Z"
              fill="#31344E"
            />
            <path
              d="M7.16195 2.81597C6.99985 2.77924 6.8324 2.75946 6.66092 2.75946C5.33734 2.75946 4.26294 3.89114 4.26294 5.28843C4.26294 6.37066 4.90731 7.29041 5.81292 7.6521C6.13712 6.41446 6.60466 4.73601 7.16061 2.81597H7.16195Z"
              fill="#31344E"
            />
          </g>
          <defs>
            <filter
              id="filter0_d_8478_40466"
              x="0"
              y="0"
              width="14.7327"
              height="36.9999"
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset dy="4" />
              <feGaussianBlur stdDeviation="2" />
              <feComposite in2="hardAlpha" operator="out" />
              <feColorMatrix
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
              />
              <feBlend
                mode="normal"
                in2="BackgroundImageFix"
                result="effect1_dropShadow_8478_40466"
              />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="effect1_dropShadow_8478_40466"
                result="shape"
              />
            </filter>
          </defs>
        </svg>
      );
    } else if (assessmentName === "Elbow Flexion") {
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="19"
          height="37"
          viewBox="0 0 19 37"
          fill="none"
        >
          <g filter="url(#filter0_d_8478_40483)">
            <path
              d="M7.10935 5.58947C8.66044 5.58947 9.91669 4.33879 9.91669 2.79455C9.91669 1.25032 8.66044 -0.000366211 7.10935 -0.000366211C5.55825 -0.000366211 4.302 1.25032 4.302 2.79455C4.302 4.33879 5.55825 5.58947 7.10935 5.58947Z"
              fill="#31344E"
            />
            <path
              d="M8.05104 14.5808H8.00086C7.65739 14.5808 7.32176 14.5214 7.00339 14.4059C6.81048 14.3356 6.22549 14.1202 5.76439 13.5221C5.28448 12.8976 5.22174 12.223 5.22802 11.8749V8.72393C5.22802 8.20086 5.4319 7.71058 5.80203 7.34365C6.17216 6.97672 6.66462 6.77217 7.18845 6.77217C8.26905 6.77217 9.14889 7.64812 9.14889 8.72393V10.7147H10.2734V9.26574C10.2734 7.83393 9.10654 6.67224 7.66837 6.67224H6.60503C5.16685 6.67224 4 7.83393 4 9.26574V16.7261C4 17.8504 4.71987 18.8091 5.72518 19.1666V27.517C5.72518 28.3368 6.39173 29.0004 7.21511 29.0004C8.0385 29.0004 8.70505 28.3368 8.70505 27.517V19.1057C9.62724 18.7076 10.2734 17.791 10.2734 16.7261V14.5995L8.05104 14.5808Z"
              fill="#31344E"
            />
            <path
              d="M14.176 12.6664C14.176 13.5721 13.4389 14.3059 12.5292 14.3059C11.0377 14.2934 9.54467 14.2809 8.05317 14.2684C7.83831 14.2731 7.49798 14.2528 7.11216 14.1123C6.91926 14.042 6.41111 13.8484 6.01432 13.3316C5.55793 12.7367 5.53911 12.0934 5.54225 11.8795V8.72389C5.54225 8.27108 5.72574 7.86043 6.02373 7.56376C6.32172 7.2671 6.73419 7.08441 7.18901 7.08441C8.09865 7.08441 8.83578 7.81827 8.83578 8.72389V11.027H12.5292C13.4389 11.027 14.176 11.7608 14.176 12.6664Z"
              fill="#31344E"
            />
          </g>
          <defs>
            <filter
              id="filter0_d_8478_40483"
              x="0"
              y="-0.000366211"
              width="18.176"
              height="37.0007"
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset dy="4" />
              <feGaussianBlur stdDeviation="2" />
              <feComposite in2="hardAlpha" operator="out" />
              <feColorMatrix
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
              />
              <feBlend
                mode="normal"
                in2="BackgroundImageFix"
                result="effect1_dropShadow_8478_40483"
              />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="effect1_dropShadow_8478_40483"
                result="shape"
              />
            </filter>
          </defs>
        </svg>
      );
    } else if (assessmentName === "Elbow Extension") {
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="19"
          height="37"
          viewBox="0 0 19 37"
          fill="none"
        >
          <g filter="url(#filter0_d_8478_40513)">
            <path
              d="M7.10947 5.58947C8.66056 5.58947 9.91681 4.33879 9.91681 2.79455C9.91681 1.25032 8.66056 -0.000366211 7.10947 -0.000366211C5.55837 -0.000366211 4.30212 1.25032 4.30212 2.79455C4.30212 4.33879 5.55837 5.58947 7.10947 5.58947Z"
              fill="#31344E"
            />
            <path
              d="M8.05104 14.5808H8.00086C7.65739 14.5808 7.32176 14.5214 7.00339 14.4059C6.81048 14.3356 6.22549 14.1202 5.76439 13.5221C5.28448 12.8976 5.22174 12.223 5.22802 11.8749V8.72393C5.22802 8.20086 5.4319 7.71058 5.80203 7.34365C6.17216 6.97672 6.66462 6.77217 7.18845 6.77217C8.26905 6.77217 9.14889 7.64812 9.14889 8.72393V10.7147H10.2734V9.26574C10.2734 7.83393 9.10654 6.67224 7.66837 6.67224H6.60503C5.16685 6.67224 4 7.83393 4 9.26574V16.7261C4 17.8504 4.71987 18.8091 5.72518 19.1666V27.517C5.72518 28.3368 6.39173 29.0004 7.21511 29.0004C8.0385 29.0004 8.70505 28.3368 8.70505 27.517V19.1057C9.62724 18.7076 10.2734 17.791 10.2734 16.7261V14.5995L8.05104 14.5808Z"
              fill="#31344E"
            />
            <path
              d="M14.1759 12.6664C14.1759 13.5721 13.4388 14.3059 12.5291 14.3059C11.0376 14.2934 9.54455 14.2809 8.05305 14.2684C7.83819 14.2731 7.49786 14.2528 7.11204 14.1123C6.91913 14.042 6.41099 13.8484 6.0142 13.3316C5.55781 12.7367 5.53899 12.0934 5.54212 11.8795V8.72389C5.54212 8.27108 5.72562 7.86043 6.02361 7.56376C6.32159 7.2671 6.73407 7.08441 7.18889 7.08441C8.09853 7.08441 8.83566 7.81827 8.83566 8.72389V11.027H12.5291C13.4388 11.027 14.1759 11.7608 14.1759 12.6664Z"
              fill="#31344E"
            />
          </g>
          <defs>
            <filter
              id="filter0_d_8478_40513"
              x="0"
              y="-0.000366211"
              width="18.1759"
              height="37.0007"
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset dy="4" />
              <feGaussianBlur stdDeviation="2" />
              <feComposite in2="hardAlpha" operator="out" />
              <feColorMatrix
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
              />
              <feBlend
                mode="normal"
                in2="BackgroundImageFix"
                result="effect1_dropShadow_8478_40513"
              />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="effect1_dropShadow_8478_40513"
                result="shape"
              />
            </filter>
          </defs>
        </svg>
      );
    } else if (assessmentName === "Internal Rotation") {
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="35"
          height="19"
          viewBox="0 0 35 19"
          fill="none"
        >
          <g filter="url(#filter0_d_8478_40536)">
            <path
              d="M13.2439 3.47262C13.0692 3.49922 12.9141 3.53822 12.5986 3.64105C12.2992 3.73856 11.8892 3.88393 11.4009 4.08959L4.99853 6.95457C4.14655 7.33574 3.76512 8.3321 4.15011 9.18131C4.53332 10.0287 5.53503 10.4081 6.38879 10.027L11.0283 7.95093C12.2849 9.25045 14.9318 10.2734 17.3327 10.3195C19.9189 10.3674 22.7119 9.28768 24.0006 7.88533L28.6116 9.94897C29.4636 10.3301 30.4653 9.94897 30.8503 9.1033C30.9519 8.87815 31 8.64413 31 8.41365C31 7.93497 30.795 7.47402 30.4314 7.15313C30.2407 6.98471 30.0571 6.90138 30.0001 6.87656C29.3566 6.59113 26.8132 5.44407 23.3233 3.87861C23.1183 3.7687 22.8331 3.64282 22.4802 3.5595C22.2057 3.49567 21.9597 3.4744 21.7619 3.47085H21.5658C21.5926 3.64637 21.6104 3.82365 21.6104 4.00626C21.6104 5.97239 19.8298 7.56444 17.8549 7.56444C15.6055 7.56444 14.1404 5.5008 14.0994 4.00626C14.0941 3.80238 14.1154 3.62155 14.144 3.47085C13.9336 3.43894 13.6182 3.41412 13.2456 3.47085L13.2439 3.47262Z"
              fill="#31344E"
            />
            <path
              d="M14.6523 3.85243C14.6523 5.60582 16.08 7.0259 17.8428 7.0259C19.6056 7.0259 21.0333 5.60582 21.0333 3.85243C21.0333 2.09905 19.6056 0.67897 17.8428 0.67897C16.08 0.67897 14.6523 2.09905 14.6523 3.85243Z"
              fill="#31344E"
            />
          </g>
          <defs>
            <filter
              id="filter0_d_8478_40536"
              x="0"
              y="0.67897"
              width="35"
              height="17.6421"
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset dy="4" />
              <feGaussianBlur stdDeviation="2" />
              <feComposite in2="hardAlpha" operator="out" />
              <feColorMatrix
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
              />
              <feBlend
                mode="normal"
                in2="BackgroundImageFix"
                result="effect1_dropShadow_8478_40536"
              />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="effect1_dropShadow_8478_40536"
                result="shape"
              />
            </filter>
          </defs>
        </svg>
      );
    } else if (assessmentName === "External Rotation") {
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="35"
          height="19"
          viewBox="0 0 35 19"
          fill="none"
        >
          <g filter="url(#filter0_d_8478_40559)">
            <path
              d="M13.2439 3.47262C13.0692 3.49922 12.9141 3.53822 12.5986 3.64105C12.2992 3.73856 11.8892 3.88393 11.4009 4.08959L4.99853 6.95457C4.14655 7.33574 3.76512 8.3321 4.15011 9.18131C4.53332 10.0287 5.53503 10.4081 6.38879 10.027L11.0283 7.95093C12.2849 9.25045 14.9318 10.2734 17.3327 10.3195C19.9189 10.3674 22.7119 9.28768 24.0006 7.88533L28.6116 9.94897C29.4636 10.3301 30.4653 9.94897 30.8503 9.1033C30.9519 8.87815 31 8.64413 31 8.41365C31 7.93497 30.795 7.47402 30.4314 7.15313C30.2407 6.98471 30.0571 6.90138 30.0001 6.87656C29.3566 6.59113 26.8132 5.44407 23.3233 3.87861C23.1183 3.7687 22.8331 3.64282 22.4802 3.5595C22.2057 3.49567 21.9597 3.4744 21.7619 3.47085H21.5658C21.5926 3.64637 21.6104 3.82365 21.6104 4.00626C21.6104 5.97239 19.8298 7.56444 17.8549 7.56444C15.6055 7.56444 14.1404 5.5008 14.0994 4.00626C14.0941 3.80238 14.1154 3.62155 14.144 3.47085C13.9336 3.43894 13.6182 3.41412 13.2456 3.47085L13.2439 3.47262Z"
              fill="#31344E"
            />
            <path
              d="M14.6523 3.85243C14.6523 5.60582 16.08 7.0259 17.8428 7.0259C19.6056 7.0259 21.0333 5.60582 21.0333 3.85243C21.0333 2.09905 19.6056 0.67897 17.8428 0.67897C16.08 0.67897 14.6523 2.09905 14.6523 3.85243Z"
              fill="#31344E"
            />
          </g>
          <defs>
            <filter
              id="filter0_d_8478_40559"
              x="0"
              y="0.67897"
              width="35"
              height="17.6421"
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset dy="4" />
              <feGaussianBlur stdDeviation="2" />
              <feComposite in2="hardAlpha" operator="out" />
              <feColorMatrix
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
              />
              <feBlend
                mode="normal"
                in2="BackgroundImageFix"
                result="effect1_dropShadow_8478_40559"
              />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="effect1_dropShadow_8478_40559"
                result="shape"
              />
            </filter>
          </defs>
        </svg>
      );
    }
  }
  return (
    <>
      <IonModal
        className="graph-assessment-description-modal-wrap"
        backdropDismiss={false}
        placeholder={undefined}
        isOpen={GraphAsseDesc}
      >
        <GraphAromDescriptionModal
          setGraphAsseDesc={setGraphAsseDesc}
          graphNameToShowInfo={graphNameToShowInfo}
        ></GraphAromDescriptionModal>
      </IonModal>
      <IonGrid placeholder={undefined}>
        <IonRow placeholder={undefined}>
          <IonCol className="col-sec " placeholder={undefined}>
            <div className="arom-result-card p-relative">
              <div className="arom-result-card-content">
                <div className="d-flex justify-content-center">
                  <div className="arom-label-image">{getGraphTitleImage()}</div>
                  <p className="arom-result-name">{assessmentName}</p>
                  <div className="exclamation-icon-graph right-margin-10">
                    <svg
                      onClick={() => {
                        handleGraphAsseDesc(assessmentName);
                      }}
                      xmlns="http://www.w3.org/2000/svg"
                      width="26"
                      height="26"
                      viewBox="0 0 26 26"
                      fill="none"
                    >
                      <path
                        d="M14.4486 11.9198C14.4486 11.1945 13.8606 10.6065 13.1353 10.6065C12.41 10.6065 11.822 11.1945 11.822 11.9198V17.9865C11.822 18.7118 12.41 19.2998 13.1353 19.2998C13.8606 19.2998 14.4486 18.7118 14.4486 17.9865V11.9198ZM13.0749 6.96648C12.3495 6.96648 11.7615 7.55448 11.7615 8.27982V8.40115C11.7615 9.12648 12.3495 9.71448 13.0749 9.71448H13.1962C13.9215 9.71448 14.5095 9.12648 14.5095 8.40115V8.27982C14.5095 7.55448 13.9215 6.96648 13.1962 6.96648H13.0749ZM13.1353 0.899817C6.379 0.899817 0.901953 6.37687 0.901953 13.1332C0.901953 19.8894 6.379 25.3665 13.1353 25.3665C19.8916 25.3665 25.3686 19.8894 25.3686 13.1332C25.3686 6.37687 19.8916 0.899817 13.1353 0.899817ZM3.52862 13.1332C3.52862 7.82753 7.82967 3.52648 13.1353 3.52648C18.4409 3.52648 22.742 7.82753 22.742 13.1332C22.742 18.4388 18.4409 22.7398 13.1353 22.7398C7.82967 22.7398 3.52862 18.4388 3.52862 13.1332Z"
                        fill="#31344E"
                        stroke="#31344E"
                        strokeWidth="0.2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </div>
                </div>
                <div className="arom-image-container-wrap">
                  <div className="arom-image-container">
                    <img
                      className="arom-result-image"
                      src={imgPath}
                      alt="imgPath"
                    />
                    <svg
                      className="arom-purple-line"
                      style={{
                        // Purple line
                        transform: `rotate(${angle_right}deg)`,
                      }}
                    >
                      <line
                        x1="50%"
                        y1="50%"
                        x2={x2_first}
                        y2={y2_first}
                        stroke="#9F3412"
                        strokeWidth="5"
                        strokeLinecap="round"
                      />
                    </svg>
                    <svg
                      className="arom-blue-line"
                      style={{
                        // Blue Line
                        transform: `rotate(${angle_left}deg)`,
                      }}
                    >
                      <line
                        x1="50%"
                        y1="50%"
                        x2={x2_second}
                        y2={y2_second}
                        stroke="#0E76BD"
                        strokeWidth="5"
                        strokeLinecap="round"
                      />
                    </svg>
                  </div>
                </div>

                <div>
                  {isNaN(left) && isNaN(right) ? (
                    <div className="arom-button-container">
                      {" "}
                      <div className="arom-left-button">{`L: --`}</div>
                      <div className="arom-right-button">{`R: --`}</div>{" "}
                    </div>
                  ) : (
                    <div className="arom-button-container">
                      <div className="arom-left-button">{`L:${left}°`}</div>
                      <div className="arom-right-button">{`R:${right}°`}</div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </IonCol>
        </IonRow>
      </IonGrid>
    </>
  );
};

export default AromResultCard;
